export default `
    id
    name
`;
